import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import DependencyTrackCredentialsForm from './DependencyTrackCredentialsForm';
import DependencyTrackConfigListing from './DependencyTrackConfigListing';

const DependencyTrackPullAndPushView = (props) => (
    <GenericPullAndPushToolView
        {...props}
        PullCredentialForm={DependencyTrackCredentialsForm}
        PullConfigListingView={DependencyTrackConfigListing}
    />
);

export default DependencyTrackPullAndPushView;